<template>
  <div>
    <app-cells><h1 class="title">Supplier invoices</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'FinanceSupplierInvoices',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'finance-supplier-invoices', label: 'Invoices'},
        { name: 'finance-supplier-invoices-payment-plan', label: 'Payment plan'},
      ],
    }
  },
}
</script>
